import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createMailRoutes(startPath: string) {
  return [
    {
      path: startPath,
      component: () => import('../layouts/mail-layout.vue'),
      redirect: () => ({ name: routeDefinitions.mail.mailInbox }),
      children: [
        {
          path: 'inbox',
          component: () => import('../layouts/mail-inbox-layout.vue'),
          children: [
            {
              path: '',
              name: routeDefinitions.mail.mailInbox,
              component: () => import('../views/mail-inbox.vue')
            },
            {
              path: ':id',
              component: () => import('../layouts/mail-message-layout.vue'),
              props: true,
              children: [
                {
                  path: '',
                  name: routeDefinitions.mailIdRoutes.mailMessage,
                  component: () => import('../views/mail-message.vue'),
                  props: true
                }
              ]
            }
          ]
        },
        {
          path: 'compose',
          name: routeDefinitions.mail.mailCompose,
          component: () => import('../views/mail-compose.vue')
        }
      ]
    }
  ] as readonly RouteRecordRaw[]
}
